/* Shared initialization for AIRSEEKERS sections. */
(() => {
  'use strict';

  if (window.ACCSections) {
    window.ACCSections.init();
    return;
  }

  const instances = new Map();

  function mount(root) {
    if (instances.has(root)) return;

    const abort = new AbortController();
    const signal = abort.signal;
    const on = (node, type, fn) =>
      node && node.addEventListener(type, fn, { signal });
    const $ = selector => root.querySelector(selector);

    let observer;
    let previousFocus;

    function close(dialog) {
      if (dialog && dialog.open) dialog.close();
    }

    function open(dialog) {
      previousFocus = document.activeElement;

      if (!dialog.open) dialog.showModal();

      dialog.querySelector('[data-close]').focus();
    }

    root.querySelectorAll('dialog').forEach(dialog => {
      dialog.querySelectorAll('[data-close]').forEach(button => {
        on(button, 'click', () => close(dialog));
      });

      on(dialog, 'click', event => {
        const bounds = dialog.getBoundingClientRect();

        if (
          event.target === dialog &&
          (
            event.clientX < bounds.left ||
            event.clientX > bounds.right ||
            event.clientY < bounds.top ||
            event.clientY > bounds.bottom
          )
        ) {
          close(dialog);
        }
      });

      on(dialog, 'close', () => {
        dialog.querySelector('.acc-video-mount')?.replaceChildren();
        dialog.querySelector('[data-shipment-list]')?.replaceChildren();

        if (previousFocus?.isConnected) previousFocus.focus();
      });
    });

    if (root.dataset.acc === 'stories') {
      const list = $('.acc-story-list');
      const cards = [...list.children];
      const dialog = $('[data-video-dialog]');

      function update() {
        const left = list.getBoundingClientRect().left;

        let first = cards.findIndex(
          card => card.getBoundingClientRect().right > left + 5
        );

        first = Math.max(0, first);

        const visible = Math.max(
          1,
          Math.round(
            list.clientWidth /
            (
              (cards[0]?.getBoundingClientRect().width || list.clientWidth) +
              20
            )
          )
        );

        $('[data-story-count]').textContent = cards.length
          ? `${first + 1}–${Math.min(cards.length, first + visible)} / ${cards.length}`
          : 'No stories yet';

        $('[data-prev]').disabled = list.scrollLeft <= 2;

        $('[data-next]').disabled =
          list.scrollLeft >= list.scrollWidth - list.clientWidth - 2;
      }

      function move(direction) {
        list.scrollBy({
          left: direction * (
            (cards[0]?.getBoundingClientRect().width || 0) + 20
          ),
          behavior: matchMedia('(prefers-reduced-motion: reduce)').matches
            ? 'auto'
            : 'smooth'
        });
      }

      on($('[data-prev]'), 'click', () => move(-1));
      on($('[data-next]'), 'click', () => move(1));
      on(list, 'scroll', update);

      on(list, 'keydown', event => {
        if (event.target !== list) return;

        if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
          event.preventDefault();
          move(event.key === 'ArrowRight' ? 1 : -1);
        }
      });

      observer = new ResizeObserver(update);
      observer.observe(list);
      update();

      root.querySelectorAll('[data-video]').forEach(button => {
        on(button, 'click', () => {
          const id = button.dataset.video.trim();

          if (!/^[\w-]{11}$/.test(id)) {
            $('.acc-video-error').textContent =
              'This video is unavailable. Please check back later.';
            return;
          }

          $('.acc-video-error').textContent = '';

          const frame = document.createElement('iframe');
          frame.title = button.getAttribute('aria-label');
          frame.allow = 'autoplay; encrypted-media; picture-in-picture';
          frame.allowFullscreen = true;
          frame.src =
            `https://www.youtube-nocookie.com/embed/${id}?autoplay=1&rel=0`;

          dialog.querySelector('.acc-video-mount').replaceChildren(frame);
          open(dialog);
        });
      });

      on(document, 'shopify:block:select', event => {
        const card = event.target.closest?.('.acc-story');

        if (card && root.contains(card)) {
          list.scrollTo({
            left: card.offsetLeft - list.offsetLeft,
            behavior: 'auto'
          });
        }
      });
    }

    if (root.dataset.acc === 'progress') {
      const dialog = $('[data-shipment-dialog]');
      const frame = $('.acc-tracking-frame');

      const text = value =>
        typeof value === 'string' || typeof value === 'number'
          ? String(value).slice(0, 2000)
          : '';

      function node(tag, value, className = '') {
        const element = document.createElement(tag);
        element.className = className;
        element.textContent = text(value);
        return element;
      }

      function show(shipments) {
        const list = $('[data-shipment-list]');
        list.replaceChildren();

        for (const shipment of shipments) {
          const card = node('article', '', 'acc-shipment');

          card.append(
            node('p', shipment.status || 'Shipment record', 'acc-label'),
            node('h3', shipment.label || 'TRON Mower')
          );

          if (/preparing\s+for\s+shipment/i.test(text(shipment.status))) {
            card.append(
              node(
                'p',
                'Your main unit is being prepared. Tracking will appear after dispatch.'
              )
            );
          } else {
            for (const [label, value] of [
              ['Shipped', shipment.shippedAt],
              ['Carrier', shipment.courier],
              ['Tracking number', shipment.trackingNumber]
            ]) {
              card.append(node('p', `${label}: ${text(value) || '—'}`));
            }
          }

          if (shipment.message) {
            card.append(node('p', shipment.message));
          }

          try {
            const url = new URL(shipment.trackingUrl);

            if (url.protocol === 'https:') {
              const link = node('a', 'Track shipment ↗');
              link.href = url.href;
              link.target = '_blank';
              link.rel = 'noopener noreferrer';
              card.append(link);
            }
          } catch (_) {
            // Missing or unsafe tracking links are not rendered.
          }

          list.append(card);
        }

        open(dialog);
      }

      // Preserve the existing Apps Script widget protocol.
      // It emits messages from a nested googleusercontent iframe.
      // Backend authorization remains the service's responsibility.
      on(window, 'message', event => {
        if (!frame) return;

        let origin;

        try {
          origin = new URL(event.origin);
        } catch (_) {
          return;
        }

        if (
          origin.protocol !== 'https:' ||
          !origin.hostname.endsWith('.googleusercontent.com')
        ) {
          return;
        }

        const data = event.data;

        if (
          !data ||
          typeof data !== 'object' ||
          data.source !== 'airseekers-tracking-widget'
        ) {
          return;
        }

        if (data.type === 'shipment-result') {
          if (
            Array.isArray(data.shipments) &&
            data.shipments.length > 0 &&
            data.shipments.length <= 30 &&
            data.shipments.every(
              shipment =>
                shipment &&
                typeof shipment === 'object' &&
                !Array.isArray(shipment)
            )
          ) {
            show(data.shipments);
          }

          return;
        }

        if (data.height == null) return;

        const height = Number(data.height);

        if (Number.isFinite(height)) {
          frame.style.height =
            Math.min(Math.max(height + 8, 120), 1200) + 'px';
        }
      });
    }

    instances.set(root, () => {
      root.querySelectorAll('dialog').forEach(close);
      abort.abort();
      observer?.disconnect();
    });
  }

  const init = () =>
    document
      .querySelectorAll('[data-acc="stories"],[data-acc="progress"]')
      .forEach(mount);

  window.ACCSections = { init };

  document.addEventListener('shopify:section:load', init);

  document.addEventListener('shopify:section:unload', event => {
    instances.forEach((cleanup, root) => {
      if (event.target.contains(root)) {
        cleanup();
        instances.delete(root);
      }
    });
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();